<template>
  <div class="box">
    <iframe
      width="100%"
      height="500"
      frameborder="0"
      style="border:0"
      src="https://maps.google.com/maps?q=Thailand&t=&z=6&ie=UTF8&iwloc=&output=embed"
      allowfullscreen>
    </iframe>
  </div>
</template>

<script setup>
</script>
